module.exports = __webpack_public_path__ + "media/academic-excellence.cf56e06a.mp4";